"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _ArrowRight = _interopRequireDefault(require("@material-ui/icons/ArrowRight"));

var _Radio = require("../radio/Radio");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    menuItem: {
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      }
    },
    disabled: {
      backgroundColor: theme.palette.action.disabled
    },
    avatar: {
      height: 24,
      marginRight: 16,
      width: 24,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    specialMenuItem: {
      '&:hover': {
        backgroundColor: '#fff'
      }
    },
    formLabel: {
      '&:hover': {
        backgroundColor: '#fff'
      }
    },
    specialDisabled: {
      backgroundColor: 'none'
    },
    checkbox: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: 'rgba(98, 76, 146, .08)'
      }
    },
    cascadeLabel: {
      flex: 1
    }
  };
});

var MenuItem = function MenuItem(_ref) {
  var disabled = _ref.disabled,
      icon = _ref.icon,
      checked = _ref.checked,
      onChange = _ref.onChange,
      radio = _ref.radio,
      checkbox = _ref.checkbox,
      children = _ref.children,
      value = _ref.value,
      label = _ref.label,
      valueName = _ref.valueName,
      onClick = _ref.onClick,
      cascade = _ref.cascade,
      className = _ref.className;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOverButton = _useState2[0],
      setIsOverButton = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOverMenu = _useState4[0],
      setIsOverMenu = _useState4[1];

  var anchorEl = (0, _react.useRef)();

  if (cascade) {
    var _anchorEl$current, _anchorEl$current$get, _anchorEl$current$get2;

    var isOpen = isOverButton || isOverMenu;
    var maxHeight = window.innerHeight - ~~(anchorEl === null || anchorEl === void 0 ? void 0 : (_anchorEl$current = anchorEl.current) === null || _anchorEl$current === void 0 ? void 0 : (_anchorEl$current$get = _anchorEl$current.getBoundingClientRect) === null || _anchorEl$current$get === void 0 ? void 0 : (_anchorEl$current$get2 = _anchorEl$current$get.call(_anchorEl$current)) === null || _anchorEl$current$get2 === void 0 ? void 0 : _anchorEl$current$get2.top) - 10;
    var minHeight = 200;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      ref: anchorEl,
      onMouseEnter: function onMouseEnter() {
        return setIsOverButton(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsOverButton(false);
      },
      onClick: onClick,
      role: "button",
      tabIndex: 0,
      onKeyDown: onClick
    }, /*#__PURE__*/_react.default.createElement(MenuItem, {
      value: value,
      icon: icon
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.cascadeLabel
    }, label), /*#__PURE__*/_react.default.createElement(_ArrowRight.default, null))), /*#__PURE__*/_react.default.createElement(_core.Popper, {
      placement: maxHeight < minHeight ? 'right-end' : 'right-start',
      open: isOpen,
      anchorEl: anchorEl.current,
      onMouseEnter: function onMouseEnter() {
        return setIsOverMenu(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsOverMenu(false);
      },
      onClick: function onClick() {
        return setIsOverMenu(false);
      },
      className: className
    }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
      style: {
        maxHeight: Math.max(maxHeight, minHeight),
        overflow: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.MenuList, null, children))));
  }

  if (radio) return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    radio: radio,
    className: disabled ? classes.specialDisabled : classes.specialMenuItem,
    disabled: disabled,
    value: value,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    className: classes.formLabel,
    value: value,
    control: /*#__PURE__*/_react.default.createElement(_Radio.Radio, null),
    label: label
  }));
  if (checkbox) return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    checkbox: checkbox,
    className: disabled ? classes.specialDisabled : classes.specialMenuItem,
    disabled: disabled,
    value: value,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      className: classes.checkbox,
      checked: checked,
      onChange: onChange,
      name: valueName,
      icon: /*#__PURE__*/_react.default.createElement(_CheckBoxOutlineBlank.default, {
        className: disabled ? null : classes.checkbox
      }),
      checkedIcon: /*#__PURE__*/_react.default.createElement(_CheckBox.default, {
        className: disabled ? classes.checkboxDisabled : classes.checkbox
      })
    }),
    label: label
  }));
  return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: disabled ? classes.disabled : classes.menuItem,
    disabled: disabled,
    value: value,
    onClick: onClick
  }, icon && /*#__PURE__*/_react.default.createElement(_core.Badge, {
    className: classes.avatar
  }, icon), children);
};

exports.MenuItem = MenuItem;
MenuItem.propTypes = {
  /**
   * Conteúdo do menuItem
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Se TRUE, o componente fica desabilitado
   */
  disabled: _propTypes.default.bool,

  /**
   * Valor do conteudo (para casos de uso em select)
   */
  value: _propTypes.default.string,

  /**
   * Ícone caso o tenha
   */
  icon: _propTypes.default.node,

  /**
   * Se TRUE o componente é do estilo radio
   */
  radio: _propTypes.default.bool,

  /**
   * Se TRUE o componente é do estilo checkbox
   */
  checkbox: _propTypes.default.bool,

  /**
   * Texto do radio button ou checkbox
   */
  label: _propTypes.default.string,

  /**
   * Nome do checkbox para manipulacao de estado
   */
  valueName: _propTypes.default.string,

  /**
   * Se TRUE, o checkbox é marcado. Serve para manipulacao de estado
   */
  checked: _propTypes.default.bool,

  /**
   * funcao para alterar estados dos componentes
   */
  onChange: _propTypes.default.func,

  /**
   * funcao executada ao selecionar um componente
   */
  onClick: _propTypes.default.func,

  /**
   * Se TRUE o componente é do estilo cascading
   */
  cascade: _propTypes.default.bool,

  /**
   * Adição de classe no componente principal
   */
  className: _propTypes.default.string
};
MenuItem.defaultProps = {
  disabled: false,
  value: '',
  icon: null,
  label: 'check?',
  radio: false,
  checkbox: false,
  valueName: '',
  checked: false,
  onChange: null,
  onClick: null,
  cascade: false,
  className: null
};
var _default = MenuItem;
exports.default = _default;